import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { Input, Suggest, FormField } from '@cian/ui-kit';
import { useVillageSuggests } from './hooks/useSuggests';
import { useFormField } from '@cian/frontend-request-form-widget';
import { jsx as _jsx } from "react/jsx-runtime";
export var VillageSuggestField = function VillageSuggestField(_ref) {
  var label = _ref.label,
    disabled = _ref.disabled,
    name = _ref.name;
  var _useFormField = useFormField({
      name: name
    }),
    setValue = _useFormField.helpers.setValue;
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    query = _React$useState2[0],
    setQuery = _React$useState2[1];
  var _useVillageSuggests = useVillageSuggests(),
    suggests = _useVillageSuggests.suggests,
    getSuggestions = _useVillageSuggests.getSuggestions,
    loading = _useVillageSuggests.isFetching;
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isSuggestOpened = _React$useState4[0],
    setIsSuggestOpened = _React$useState4[1];
  var handleOpenSuggest = React.useCallback(function () {
    setIsSuggestOpened(true);
  }, [setIsSuggestOpened]);
  var handleCloseSuggest = React.useCallback(function () {
    setIsSuggestOpened(false);
  }, [setIsSuggestOpened]);
  var handleValueChange = React.useCallback(function (_, value) {
    setQuery(value);
    getSuggestions(value);
  }, [getSuggestions]);
  var handleItemClick = React.useCallback(function (item) {
    setQuery(item.title);
    setValue(item.value);
    handleCloseSuggest();
  }, [handleCloseSuggest, setValue]);
  React.useEffect(function () {
    if (suggests.length) {
      handleOpenSuggest();
    }
  }, [handleOpenSuggest, suggests]);
  return /*#__PURE__*/_jsx(FormField, {
    label: label,
    withoutMargin: true,
    children: /*#__PURE__*/_jsx(Suggest, {
      open: isSuggestOpened,
      suggestions: suggests,
      onSelect: handleItemClick,
      onClose: handleCloseSuggest,
      maxHeight: 140,
      children: /*#__PURE__*/_jsx(Input, {
        size: "XS",
        loading: loading,
        value: query,
        onChange: handleValueChange,
        onFocus: handleOpenSuggest,
        disabled: disabled
      })
    })
  });
};